import { render, staticRenderFns } from "./InvesteeAllData.vue?vue&type=template&id=d7cea7c4&"
import script from "./InvesteeAllData.vue?vue&type=script&lang=js&"
export * from "./InvesteeAllData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports